import { MenuIcon } from "components/AppHeader/Mobile/MobileHeader";
import Preloader from "components/Preloader/Preloader";
import { useSearch } from "hooks/useSearch";
import React, { useEffect, useRef } from "react";
import { MdClose } from "react-icons/md";
import styled from "styled-components";
import { colors, zIndexes } from "theme/Theme";
import SearchResult from "./SearchResult";

interface Props {
  onClick: (event: any) => void;
}
const MobileSearchResult: React.FC<Props> = ({ onClick }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { searchTerm, result, isSearching, viewAll, onSearch } = useSearch();
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <>
      <MobileSearchResultContainer>
        <InputContainer>
          <TextInput ref={inputRef} value={searchTerm} onChange={onSearch}></TextInput>
          <MenuIcon onClick={onClick}>
            <MdClose color={colors.dark_gray} size="2em" />
          </MenuIcon>
        </InputContainer>
        <Results>{isSearching ? <Preloader /> : <SearchResult result={result} viewAll={viewAll} />}</Results>
      </MobileSearchResultContainer>
      <Overlay onClick={onClick} />
    </>
  );
};

const MobileSearchResultContainer = styled.div`
  position: absolute;
  top: 50px;
  left: 0px;
  right: 0px;
  background-color: white;
  z-index: ${zIndexes.backdrop + 1};
`;
const InputContainer = styled.div`
  height: 50px;
  width: 100%;
  background-color: white;
  display: inline-flex;
  align-items: center;
`;
const TextInput = styled.input`
  box-sizing: border-box;
  height: 46px;
  background-color: white;
  width: 100%;
  padding: 0 10px 0 10px;
  margin: 2.5px 5px 2.5px 5px;
  border: none;
  border-bottom: 1px ${colors.dark_gray} solid;
  outline: none;
  font-size: 16px;
`;

const Results = styled.div`
  display: flex;
  flex-direction: column;
  /* padding-bottom: 10px; */
  max-height: 50vh;
  overflow-y: auto;
`;

const Overlay = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: ${zIndexes.backdrop};
`;
export default MobileSearchResult;
